import { coneSparks, shockwave } from '../effects/factories';
import type { EffectDefinition } from '../effects/types';
import { createModuleIcon } from './icons';
import { projectileAngle } from './render-utils';
import type { ModulePresentation } from './types';
const NeedleIcon = createModuleIcon(
	<>
		<path className="module-icon__thick" d="M2 25l8-4" />
		<path className="module-icon__line" d="M10 8L23 2v22l-13 6z" />
		<ellipse className="module-icon__line" cx="17" cy="16" rx="3" ry="6" />
		<path className="module-icon__thick" d="M17 16l13-6" />
	</>,
);
const color = '#ff4d8d';
const effects: readonly EffectDefinition[] = [
	{
		id: 'module:needle:muzzle',
		lifetime: 0.24,
		layer: 'air',
		render: (frame, painter) => {
			painter.ring(frame.x, frame.y, 4 + frame.easeOut(3) * 38, 3 * frame.fout, frame.color, frame.fout);
			for (const sign of [-1, 1]) {
				painter.triangle(
					frame.x,
					frame.y,
					12 * frame.fout,
					55,
					frame.rotation + (sign * Math.PI) / 2,
					frame.color,
					frame.fout,
				);
			}
			painter.triangle(frame.x, frame.y, 7 * frame.fout, 46 * frame.fout, frame.rotation, '#ffffff', frame.fout);
		},
	},
	shockwave({ id: 'module:needle:hit-ring', lifetime: 0.2, radius: 22, stroke: 2 }),
	coneSparks({
		id: 'module:needle:hit-sparks',
		lifetime: 0.35,
		count: 9,
		distance: 46,
		cone: 0.22,
		length: 13,
		stroke: 1.7,
	}),
];
export const needleModule: ModulePresentation = {
	id: 'needle',
	icon: NeedleIcon,
	meta: {
		color,
		displayColor: '#ff4d8d',
		tint: '#ffe9f1',
	},
	effects,
	renderProjectile: ({ ctx, projectile }) => {
		const angle = projectileAngle(projectile.velocity);
		ctx.save();
		ctx.translate(projectile.position.x, projectile.position.y);
		ctx.rotate(angle);
		ctx.fillStyle = '#86183f';
		ctx.strokeStyle = '#ff6fa5';
		ctx.lineWidth = 0.9;
		ctx.beginPath();
		ctx.moveTo(13, 0);
		ctx.lineTo(-4.5, -3);
		ctx.lineTo(-1.5, 0);
		ctx.lineTo(-4.5, 3);
		ctx.closePath();
		ctx.fill();
		ctx.stroke();
		ctx.fillStyle = color;
		ctx.beginPath();
		ctx.moveTo(12, 0);
		ctx.lineTo(-3.3, -2.3);
		ctx.lineTo(-1.5, 0);
		ctx.closePath();
		ctx.fill();
		ctx.strokeStyle = '#fff0f6';
		ctx.lineWidth = 0.85;
		ctx.beginPath();
		ctx.moveTo(-2.3, -1.7);
		ctx.lineTo(12, 0);
		ctx.stroke();
		ctx.restore();
	},
};
